import React from 'react';
import { Box } from '@mui/material';
import { SurveyModel } from 'survey-core';
import StatusMessageAlert from '../status-message/status-message';
import SurveyPage from '../survey-page/survey-page';

type SurveyProps = {
  surveyModel: SurveyModel;
  afterQuestions?: React.ReactNode;
}

const Survey: React.FC<SurveyProps> = ({
  surveyModel,
  afterQuestions = null,
}) => {
  return (
    <Box sx={{ backgroundColor: '#f3f3f3' }}>
      <StatusMessageAlert autoHide={true} />
      <SurveyPage
        afterQuestions={afterQuestions}
        surveyModel={surveyModel}
      />
    </Box>
  );
};

export default Survey;
